import { useTranslation } from 'react-i18next';
import { Heading, LiliButton, LiliButtonType, FontWeight } from '@lili/lili-frontend-common';

interface ResumeApplicationModalProps {
  onClose: () => void;
}

export const ResumeApplicationModal = ({ onClose }: ResumeApplicationModalProps) => {
  const { t } = useTranslation();

  return (
    <div className='w-full md:w-[420px] bg-surface-primary-bw-00 rounded-[12px] p-[32px] flex flex-col items-center px-[42px] py-[32px]'>
      <Heading.H4 className='text-center mb-[24px]' fontWeight={FontWeight.SEMIBOLD}>
        {t('pages.home.resumeModal.title')}
      </Heading.H4>
      <Heading.H9 className='text-text-main-secondary text-center mb-[32px]'>
        {t('pages.home.resumeModal.body')}
      </Heading.H9>
      <LiliButton
        id='resume-application-continue'
        title={t('pages.home.resumeModal.cta')}
        type={LiliButtonType.PRIMARY}
        className='w-[148px]'
        onClick={onClose}
      />
    </div>
  );
};
